import React, { useState, useEffect } from "react";
import "./Header.css";
import { Link } from "react-router-dom";

function Header({ setOverlay }) {
  const [width, setWidth] = useState(window.innerWidth);
  const [overlayed, setOverlayed] = useState(true);
  const [background, setBackground] = useState("");
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
  });
  useEffect(() => {
    setOverlayed(!overlayed);
    setOverlay(overlayed ? "overlay" : "no_overlay");
  }, []);
  const barsClicked = () => {
    setOverlayed(!overlayed);
    setOverlay(overlayed ? "overlay" : "no_overlay");
  };
  const handleScroll = (event) => {
    if (window.scrollY === 0) {
      setBackground("");
      return;
    }
    setBackground("setBlack_bk");
  };
  window.addEventListener("scroll", handleScroll);
  return (
    <div className={`header ${background}`}>
      <Link to="/#scroll__banner">
        <h2 className="header__brandName">
          Yuvraj<span>.</span>
        </h2>
      </Link>

      <div className="header__options">
        {width <= 450 ? (
          <div onClick={barsClicked} className="header__bars">
            <span className="header__firstBar"></span>
            <span className="header__firstBar"></span>
            <span className="header__secondBar"></span>
          </div>
        ) : (
          <>
            <a href="/#scroll__banner">
              <h4>Home</h4>
            </a>
            <a href="/#contact">
              <h4>Contact</h4>
            </a>
            <Link to="/about">
              <h4>About us</h4>
            </Link>
            <Link to="/articles">
              <h4>Articles</h4>
            </Link>
            <a href="/#work">
              <h4>Work</h4>
            </a>
          </>
        )}
      </div>
    </div>
  );
}

export default Header;
